import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { userService, reviewService } from '../../services';
import { AUTH_QUERY_KEY } from './useAuth';

export const MY_PROFILE_QUERY_KEY = 'myProfile';

export function useMyReviews(enabled = true) {
  return useQuery({
    queryKey: [MY_PROFILE_QUERY_KEY, 'reviews'],
    queryFn: () => reviewService.getMyReviews(),
    enabled,
  });
}

export function useMySubscribers(enabled = true) {
  return useQuery({
    queryKey: [MY_PROFILE_QUERY_KEY, 'subscribers'],
    queryFn: () => userService.getMySubscribers(),
    enabled,
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (profileData) => userService.updateProfile(profileData),
    onSuccess: () => {
      queryClient.invalidateQueries([AUTH_QUERY_KEY, 'current']);
      queryClient.invalidateQueries([MY_PROFILE_QUERY_KEY]);
    },
  });
}
